export const LOCAL_STORAGE = {
  USER_ID: 'riksja_user_id',
  USER_IP_HASH: 'riksja_user_ip_hash',
  CART_ITEMS: 'riksja_cart_items',
  WISHLIST_ITEMS: 'riksja_wishlist_items',
  TRANSLATIONS: 'translations',
  WP_URL: 'wp_url',
  FE_URL: 'fe_url',
}
